// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsEventController from "./analytics_event_controller"
application.register("analytics-event", AnalyticsEventController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CountyMapController from "./county_map_controller"
application.register("county-map", CountyMapController)

import DesignCardController from "./design_card_controller"
application.register("design-card", DesignCardController)

import FernDemoController from "./fern_demo_controller"
application.register("fern-demo", FernDemoController)

import FernConfigurationStatusController from "./fern_configuration_status_controller"
application.register("fern-configuration-status", FernConfigurationStatusController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavMenuController from "./nav_menu_controller"
application.register("nav-menu", NavMenuController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NestedRemoveController from "./nested_remove_controller"
application.register("nested-remove", NestedRemoveController)

import OrderMapController from "./order_map_controller"
application.register("order-map", OrderMapController)

import OrderMapEditController from "./order_map_edit_controller"
application.register("order-map-edit", OrderMapEditController)

import PostcardBackController from "./postcard_back_controller"
application.register("postcard-back", PostcardBackController)

import PostcardFrontController from "./postcard_front_controller"
application.register("postcard-front", PostcardFrontController)

import VideoGateController from "./video_gate_controller"
application.register("video-gate", VideoGateController)

import MessagePreviewController from "./message_preview_controller"
application.register("message-preview", MessagePreviewController)

import DonutChartController from "./donut_chart_controller"
application.register("donut-chart", DonutChartController)

import LineChartController from "./line_chart_controller"
application.register("line-chart", LineChartController)

import ActivityFeedController from "./activity_feed_controller"
application.register("activity-feed", ActivityFeedController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SavingsCalculatorController from "./savings_calculator_controller"
application.register("savings-calculator", SavingsCalculatorController)

import RecipientTableController from "./recipient_table_controller"
application.register("recipient-table", RecipientTableController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import RecipientMapController from "./recipient_map_controller"
application.register("recipient-map", RecipientMapController)


import EngagementCardsController from "./engagement_cards_controller"
application.register("engagement-cards", EngagementCardsController)

import EngagementTabsController from "./engagement_tabs_controller"
application.register("engagement-tabs", EngagementTabsController)

import StackedBarChartController from "./stacked_bar_chart_controller"
application.register("stacked-bar-chart", StackedBarChartController)

import SortableListController from "./sortable_list_controller"
application.register("sortable-list", SortableListController)

import ColorPaletteController from "./color_palette_controller"
application.register("color-palette", ColorPaletteController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import VisitTrackerController from "./visit_tracker_controller"
application.register("visit-tracker", VisitTrackerController)

import ImagineThreadController from "./imagine_thread_controller"
application.register("imagine-thread", ImagineThreadController)

import ImagineStatusController from "./imagine_status_controller"
application.register("imagine-status", ImagineStatusController)

import ImagineControlController from "./imagine_control_controller"
application.register("imagine-control", ImagineControlController)

import ImagineOtherController from "./imagine_other_controller"
application.register("imagine-other", ImagineOtherController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)
